import { render, staticRenderFns } from "./deviceManagement.vue?vue&type=template&id=12c689d2&scoped=true&"
import script from "./deviceManagement.vue?vue&type=script&lang=js&"
export * from "./deviceManagement.vue?vue&type=script&lang=js&"
import style0 from "./deviceManagement.vue?vue&type=style&index=0&id=12c689d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c689d2",
  null
  
)

export default component.exports